<!-- 新增内部属性 -->
<template>
  <div class="popattrcontent">
    <el-form :label-position="labelPosition" label-width="100px" class="demo-ruleForm" :rules="rules" :model="form">
      <el-form-item :label="title + '名称'" prop="name">
        <el-input v-model="form.name" size="mini"></el-input>
      </el-form-item>
      <el-form-item :label="title + '值'" prop="value">
        <el-input v-model="form.value" size="mini"></el-input>
      </el-form-item>
      <el-form-item v-if="is_button">
        <el-button type="primary" @click="onSubmit" size="mini">保存</el-button>
        <!-- <el-button  size="mini" @click="close">取消</el-button> -->
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { getAddInnerAttrApi, getAddServeApi, getAddParamApi } from "@/api/mall";

export default {
  props:{
    // 类别
    classid: {
      default: () =>{
        return 0;
      }
    },
    // 标题
    title: {
      default: () => {
        return "";
      }
    },
    nameValue: {
      default: () => {
        return nameValue;
      }
    },
    is_button:{
      default:true,
    }
  },
  data () {
    return {
      labelPosition:"right",
      form: {
        name:"",
        value:"",
      },
      rules: {
        name: [
          { required: true, message: '请输入名称', trigger: 'blur' },
        ],
        value: [
          { required: true, message: '请输入值', trigger: 'blur' },
        ],
      }
    };
  },
  
  components: {},
  computed: {
    ...mapGetters(["token", "app_id", "merch_id"]),
    
  },
  watch:{
    nameValue(val){
      this.form.name = val;
      console.log("wobianhua",val)
    }
  },
  mounted(){
    this.form.name = this.nameValue;
  },
  methods:{
    // 保存
    onSubmit(){
      var data = {
        token: this.token,
        app_id: this.app_id,
        merch_id: this.merch_id,
        name: this.form.name,
        value: this.form.value,
      }
      switch (this.classid) {
        case 3:
          this.addinner(data);
          break;
        case 4:
          this.addParam(data);
          break;
        case 5:
          this.addServe(data);
          break;
      }
    },
    // 判断类型
    judeClass(index){
      console.log("传入的类型", index);
      console.log("传入的类型", this.nameValue);
    },
    // close
    close(){

      this.$parent.is_collectPop = false;
      console.log("父组件的值", this.$parent.is_collectPop);
    },
    //内部属性添加
    addinner(data){
      getAddInnerAttrApi(data).then(res => {
        if(res.code == 1){
          this.$emit("closePop", false);
          this.form.name = "";
          this.form.value = "";
          this.$message({
            message: res.msg,
            type: 'success'
          });
          this.$parent.is_collectPop = false;
          console.log(res.msg);
        } else {
          this.$message({
            message: "上传内部属性失败",
            type: 'warning',
          });
        }
      });
    },
    //商品服务添加
    addServe(data){
      getAddServeApi(data).then(res => {
        if(res.code == 1){
          this.$emit("closePop", false);
          this.form.name = "";
          this.form.value = "";
          this.$message({
            message: res.msg,
            type: 'success'
          });
          console.log("服务",res.msg);
        } else {
          this.$message({
            message: "上传商品服务失败",
            type: 'warning',
          });
        }
      });
    },
    //商品参数添加
    addParam(data){
      getAddParamApi(data).then(res => {
        if(res.code == 1){
          this.$emit("closePop", false);
          this.form.name = "";
          this.form.value = "";
          this.$message({
            message: res.msg,
            type: 'success'
          });
          console.log(res.msg);
        } else {
          this.$message({
            message: "上传商品参数失败",
            type: 'warning',
          });
        }
      });
    },
  }
};
</script>
<style lang="scss">

</style>